var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliveryDetailsType !== _vm.VS_STOCK_TYPE_DELIVERY_METHOD.UNKNOWN
    ? _c("div", { staticClass: "summary__right" }, [
        _c(
          "section",
          { staticClass: "detail stock-type" },
          [
            _c("h3", { staticClass: "section__heading" }, [_vm._v("Delivery")]),
            _vm._v(" "),
            _vm.order.event.is_guest_list
              ? [
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-ticket-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.billingAddress.first_name) +
                                " " +
                                _vm._s(_vm.billingAddress.last_name)
                            )
                          ]),
                          _vm._v(
                            " will be added to the guest list once your order is confirmed."
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.TICKETMASTER_TRANSFER ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Mobile Access")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Instructions on how to access your tickets will be emailed to "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ]),
                          _vm._v(" when your tickets are released")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._m(1)
                  ])
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.TICKETMASTER_TEXT_TRANSFER ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Mobile Access")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Instructions on how to access your tickets will be sent by text message to "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.billingAddress.phone_number))
                          ]),
                          _vm._v(" when your tickets are released")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._m(3)
                  ])
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD
                  .TICKETMASTER_INSTANT_TRANSFER === _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Instant Mobile Access")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Instructions on how to access your tickets will be emailed to "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ]),
                          _vm._v(" in the next few minutes")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(4)
                  ])
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.E_TICKETS_INSTANT ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Instant Download")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("Your tickets will be emailed to "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ]),
                          _vm._v(" in the next few minutes")
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.order.current_status === _vm.ORDER_STATUS.SENT_TO_BUYER
                    ? _c(
                        "div",
                        { staticClass: "ticket-download" },
                        [
                          _vm.hasTicketEmailDownload
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "ticket-download__action order__action",
                                    attrs: {
                                      target: "_blank",
                                      href:
                                        _vm.order.ticket.fulfillment.links[0]
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Download\n                    "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasTicketPdfDownload
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "ticket-download__action order__action",
                                    attrs: {
                                      target: "_blank",
                                      href: _vm.order.ticket.fulfillment.pdf.url
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Download\n                    "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_WALK_IN ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Local Pickup")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-print-ticket"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Location details and contact information will be sent to "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.E_TICKETS ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("E-mail Delivery")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("Your tickets will be emailed to "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ]),
                          _vm._v(" when they are released")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(6)
                  ])
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.FLASH ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("AXS Mobile ID (formerly Flash Seats®)")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-alert"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "If you do not have a AXS Mobile ID (formerly Flash Seats®) account, sign up on "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://axs.com",
                                target: "_blank"
                              }
                            },
                            [_vm._v("axs.com")]
                          ),
                          _vm._v(" using email address "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(7),
                    _vm._v(" "),
                    _vm._m(8)
                  ])
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.HARD_COURIERED_TO_CUSTOMER ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Shipped via UPS")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-truck"
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm._v("Tickets will be shipped to "),
                            _c("ShippingAddress", {
                              attrs: { "shipping-address": _vm.shippingAddress }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("A tracking number will be sent to "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ]),
                          _vm._v(" when the tickets have been shipped")
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.hasTicketTrackingNumber
                    ? _c("div", { staticClass: "tracking-information" }, [
                        _c(
                          "h3",
                          { staticClass: "tracking-information__header" },
                          [_vm._v("Tracking Number")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tracking-information__tracking_number"
                          },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.order.ticket.delivery_method
                                )
                              }
                            }),
                            _vm._v(
                              " #" +
                                _vm._s(
                                  _vm.order.ticket.fulfillment.tracking.number
                                ) +
                                " "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "order__action",
                            attrs: {
                              target: "_blank",
                              href: _vm.order.ticket.fulfillment.tracking.url
                            }
                          },
                          [
                            _vm._v(
                              "\n                        Track My Order\n                "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.HARD_PICKUP_NEAR_VENUE ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Local Pickup")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-truck"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Pick up your tickets near the venue before your event. Location details and contact information will be sent to "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("A tracking number will be sent to "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(9)
                  ]),
                  _vm._v(" "),
                  _vm.hasTicketTrackingNumber
                    ? _c("div", { staticClass: "tracking-information" }, [
                        _c(
                          "h3",
                          { staticClass: "tracking-information__header" },
                          [_vm._v("Tracking Number")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tracking-information__tracking_number"
                          },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.order.ticket.delivery_method
                                )
                              }
                            }),
                            _vm._v(
                              " #" +
                                _vm._s(
                                  _vm.order.ticket.fulfillment.tracking.number
                                ) +
                                " "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "order__action",
                            attrs: {
                              target: "_blank",
                              href: _vm.order.ticket.fulfillment.tracking.url
                            }
                          },
                          [
                            _vm._v(
                              "\n                        Track My Order\n                "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.HARD_DELIVERED_TO_VENUE ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Local Pickup")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _vm._m(10),
                    _vm._v(" "),
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Location details and contact information will be sent to "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.hasTicketTrackingNumber
                    ? _c("div", { staticClass: "tracking-information" }, [
                        _c(
                          "h3",
                          { staticClass: "tracking-information__header" },
                          [_vm._v("Tracking Number")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tracking-information__tracking_number"
                          },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.order.ticket.delivery_method
                                )
                              }
                            }),
                            _vm._v(
                              " #" +
                                _vm._s(
                                  _vm.order.ticket.fulfillment.tracking.number
                                ) +
                                " "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "order__action",
                            attrs: {
                              target: "_blank",
                              href: _vm.order.ticket.fulfillment.tracking.url
                            }
                          },
                          [
                            _vm._v(
                              "\n                        Track My Order\n                "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.LAST_MINUTE ===
                _vm.deliveryDetailsType
              ? [
                  _c("ul", { staticClass: "delivery-details" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Location details and contact information will be sent to "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.MOBILE_SCREENCAP_INSTANT ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Instant Mobile Email Delivery")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("Your tickets will be emailed to "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ]),
                          _vm._v(" in the next few minutes")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(12)
                  ]),
                  _vm._v(" "),
                  _vm.order.current_status === _vm.ORDER_STATUS.SENT_TO_BUYER
                    ? _c(
                        "div",
                        { staticClass: "ticket-download" },
                        [
                          _vm.hasTicketEmailDownload
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "ticket-download__action order__action",
                                    attrs: {
                                      target: "_blank",
                                      href:
                                        _vm.order.ticket.fulfillment.links[0]
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Download\n                    "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasTicketPdfDownload
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "ticket-download__action order__action",
                                    attrs: {
                                      target: "_blank",
                                      href: _vm.order.ticket.fulfillment.pdf.url
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Download\n                    "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.MOBILE_SCREENCAP ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Mobile Email Delivery")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("Your tickets will be emailed to "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ]),
                          _vm._v(" when they are released")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(13),
                    _vm._v(" "),
                    _vm._m(14)
                  ]),
                  _vm._v(" "),
                  _vm.order.current_status === _vm.ORDER_STATUS.SENT_TO_BUYER
                    ? _c(
                        "div",
                        { staticClass: "ticket-download" },
                        [
                          _vm.hasTicketEmailDownload
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "ticket-download__action order__action",
                                    attrs: {
                                      target: "_blank",
                                      href:
                                        _vm.order.ticket.fulfillment.links[0]
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Download\n                    "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasTicketPdfDownload
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "ticket-download__action order__action",
                                    attrs: {
                                      target: "_blank",
                                      href: _vm.order.ticket.fulfillment.pdf.url
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Download\n                    "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_CARD_AT_VENUE ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Local Pickup")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _vm._m(15),
                    _vm._v(" "),
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Location details and contact information will be sent to "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_CARD_COURIERED ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Shipped via UPS")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-truck"
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm._v("Tickets will be shipped to "),
                            _c("ShippingAddress", {
                              attrs: { "shipping-address": _vm.shippingAddress }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("A tracking number will be sent to "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ]),
                          _vm._v(" when the tickets have been shipped")
                        ])
                      ])
                    ])
                  ])
                ]
              : _vm.VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_CARD_NEAR_VENUE ===
                _vm.deliveryDetailsType
              ? [
                  _c("h4", [_vm._v("Local Pickup")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "delivery-details" }, [
                    _vm._m(16),
                    _vm._v(" "),
                    _c("li", { staticClass: "stock-type__item" }, [
                      _c("div", { staticClass: "display-flex" }, [
                        _c("span", {
                          staticClass: "stock-type__icon icon-email-2"
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Location details and contact information will be sent to "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.order.customer.email_address))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.deliveryDate
          ? _c("section", { staticClass: "detail" }, [
              _c("h3", { staticClass: "detail__heading" }, [
                _vm._v("Expected Delivery")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "detail__body" }, [
                _vm._v(_vm._s(_vm._f("date")(_vm.deliveryDate)))
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-print-ticket" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Typically tickets are released quickly, but some venues withhold tickets until 48 hours prior to the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-mobile-qr" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Tickets must be displayed on your iOS or Android device to gain access to the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-print-ticket" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Typically tickets are released quickly, but some venues withhold tickets until 48 hours prior to the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-mobile-qr" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Tickets must be displayed on your iOS or Android device to gain access to the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-mobile-qr" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Tickets must be displayed on your iOS or Android device to gain access to the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-email-2" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Tickets will be available on the venue premises on the day of the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-print-ticket" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Typically tickets are released quickly, but some venues withhold tickets until 48 hours prior to the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-ticket-2" }),
        _vm._v(" "),
        _c("span", [
          _vm._v("Tickets will be transferred to your AXS Mobile ID account")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-mobile-qr" }),
        _vm._v(" "),
        _c("span", [
          _vm._v("Display tickets in the AXS Mobile ID App for entry")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-ticket-2" }),
        _vm._v(" "),
        _c("span", [_vm._v("At the venue, present your tickets for entry")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-truck" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Tickets will be available on the venue premises on the day of the event."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-location-marker" }),
        _vm._v(" "),
        _c("span", [
          _vm._v("Tickets will be available for pick-up at/near the venue")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-mobile-qr" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Tickets must be displayed on your iOS or Android device to gain access to the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-email-2" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Typically tickets are released quickly, but some venues withhold tickets until 48 hours prior to the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-mobile-qr" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Tickets must be displayed on your iOS or Android device to gain access to the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-truck" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Tickets will be available on the venue premises on the day of the event"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "stock-type__item" }, [
      _c("div", { staticClass: "display-flex" }, [
        _c("span", { staticClass: "stock-type__icon icon-truck" }),
        _vm._v(" "),
        _c("span", [
          _vm._v("Pick up your tickets near the venue before your event")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }